
<modal :state="state" :index="index" @toggle-modal="$emit('paste')" class="md">
  <div :slot="ModalStatus.Confirmation">
    <p>We've noticed you are pasting a list of comma/semicolon separated items, would you like each of these items to be entered as individual values?</p>
    <div class="cta">
      <button @click="$emit('paste')" type="button" class="btn red outline block">No, thank you!</button>
      <button @click="$emit('bulk-add')" type="button" class="btn green block">Yes, please!</button>
    </div>
  </div>
  <div :slot="ModalStatus.InProgress">
    <h3 class="modal-title">Creating options...</h3>
    <p>This will take just a second.</p>
  </div>
</modal>
